import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  requestPasswordsFailed,
  requestPasswordsSuccess,
  requestPasswordDetailSuccess,
  requestPasswordDetailFailed
} from '../../actions/resources/Password';
import PasswordAPI from '../../api/resources/Password';
import * as Constants from '../../constants/resources';

function* getPasswords(data: {
  payload: { currentPage: number; pageSize: number; filter: string };
  type: Constants.PASSWORDS;
}) {
  try {
    const passwords = yield call(PasswordAPI.getPasswords, data.payload);
    yield put(requestPasswordsSuccess(passwords));
  } catch (e) {
    yield put(requestPasswordsFailed());
  }
}

function* watchForPasswords() {
  yield takeLatest(Constants.PASSWORDS, getPasswords);
}

function* getPasswordDetail(payload: { passwordVMID: string; type: string }) {
  try {
    const passwordDetail = yield call(
      PasswordAPI.getPasswordDetail,
      payload.passwordVMID
    );
    yield put(requestPasswordDetailSuccess(passwordDetail));
  } catch (e) {
    yield put(requestPasswordDetailFailed());
  }
}

function* watchForPasswordDetail() {
  yield takeLatest(Constants.PASSWORD_DETAIL, getPasswordDetail);
}

export default function* homeSaga() {
  yield all([
    watchForPasswords(),
    watchForPasswordDetail()
  ]);
}
